// extracted by mini-css-extract-plugin
export var active = "dots-module--active--sCDbw";
export var dot = "dots-module--dot--XcsIV";
export var dots = "dots-module--dots--a1Kzu";